var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',_vm._b({key:_vm.dateRangeKey},'b-form-group',_vm.commonFormGroupProps,false),[_c('date-range',{attrs:{"value":_vm.value,"enable-time":_vm.item.enableTime},on:{"input":_vm.handleDateRangeInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }